// 封装token的存储
// token存储到localStorage

// 存token
export function saveGetInfo(info) {
  localStorage.setItem("getInfo", info);
}
// 读取token
export function getnGetInfo() {
  return localStorage.getItem("getInfo");
}
// 删除token
export function deleteGetInfo() {
  localStorage.removeItem("getInfo");
}
